import styles from "@css/modules/Resort.module.scss"
import { Carousel } from "../../Animation/Carousel"
import { ArrowLeftThin } from "@css/icons/SVG"
import { LazyLoadImage } from "react-lazy-load-image-component"
import React from "react"
import { SlideAppear } from "../../Animation/SlideAppear"

export function ResortCarousel({ items }) {
    const prevBtn = (click) => (
        <button onClick={click} className={styles.prevBtn} aria-label="go prev">
            <ArrowLeftThin />
        </button>
    )
    const nextBtn = (click) => (
        <button onClick={click} className={styles.nextBtn} aria-label="go next">
            <ArrowLeftThin />
        </button>
    )
    return (
        <SlideAppear className={styles.galleryRoot}>
            <Carousel
                startAt={0}
                autoplayTime={0}
                classNames={{
                    itemActive: styles.itemActive,
                    item: styles.item,
                    itemNext: styles.itemNext,
                    itemPrev: styles.itemPrev,
                    root: styles.carousel
                }}
                prevBtn={prevBtn}
                nextBtn={nextBtn}
                items={items.map((i, key) => {
                    const format = i.formats.medium || i.formats.thumbnail
                    return (
                        <LazyLoadImage
                            useIntersectionObserver
                            key={key}
                            className={styles.carouselImage}
                            alt={i.alt}
                            height={format.height}
                            src={format.url}
                            width={format.width}
                        />
                    )
                })}
            />
        </SlideAppear>
    )
}
